"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../../../../utils/constants");
var _utils = require("../../../../utils/utils");
class BaseQuestion {
  constructor(_ref) {
    let {
      question,
      selections,
      metadata
    } = _ref;
    this.question = {};
    this.selections = [];
    this.metadata = {};
    this.metadataModifiers = {
      weights: {},
      filters: {},
      ranges: {},
      targetPoints: {},
      targetValues: {},
      targetStringValues: {}
    };
    this.getMinRange = function (minValue) {
      let range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        min: 0,
        max: null
      };
      let isCumulative = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      const min = isCumulative ? range.min + minValue : Math.max(range.min, minValue);
      return {
        min,
        max: range.max === null ? _constants.UNLIMITED_VALUE : range.max
      };
    };
    this.getMaxRange = function (maxValue) {
      var _range$max;
      let range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        min: 0,
        max: null
      };
      let isCumulative = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      const max = isCumulative ? ((_range$max = range.max) !== null && _range$max !== void 0 ? _range$max : 0) + maxValue : Math.min(range.max === null ? _constants.UNLIMITED_VALUE : range.max, maxValue);
      return {
        min: range.min,
        max
      };
    };
    this.checkCategory = category => {
      if (!this.metadata[category]) {
        this.metadata[category] = (0, _utils.clone)(this.metadataModifiers);
      }
    };
    this.handleRecommendationCategories = rcs => {
      if (rcs) {
        rcs.forEach(answerRc => {
          var _this$metadata$recomm;
          this.metadata.recommendationCategories = (_this$metadata$recomm = this.metadata.recommendationCategories) !== null && _this$metadata$recomm !== void 0 ? _this$metadata$recomm : [];
          let metaRc = this.metadata.recommendationCategories.find(rc => answerRc.category === rc.category);
          if (!metaRc) {
            // if not exists, just push the new one
            metaRc = {
              ...answerRc,
              fixedOfferings: answerRc.fixedOfferings.filter(fixedOffering => {
                var _fixedOffering$if;
                return !fixedOffering.if || this.matchFlagRegex(this.metadata.flags, (_fixedOffering$if = fixedOffering === null || fixedOffering === void 0 ? void 0 : fixedOffering.if) !== null && _fixedOffering$if !== void 0 ? _fixedOffering$if : []);
              })
            };
            this.metadata.recommendationCategories.push(metaRc);
          } else {
            var _metaRc$fixedOffering, _answerRc$fixedOfferi;
            metaRc.fixedOfferings = (_metaRc$fixedOffering = metaRc.fixedOfferings) !== null && _metaRc$fixedOffering !== void 0 ? _metaRc$fixedOffering : [];
            (_answerRc$fixedOfferi = answerRc.fixedOfferings) === null || _answerRc$fixedOfferi === void 0 ? void 0 : _answerRc$fixedOfferi.forEach(fo => {
              var _fo$if;
              const found = metaRc.fixedOfferings.find(o => o.category === fo.category && o.subCategory === fo.subCategory);
              if (!found) {
                metaRc.fixedOfferings.push(fo);
              } else if (!fo.if || this.matchFlagRegex(this.metadata.flags, (_fo$if = fo === null || fo === void 0 ? void 0 : fo.if) !== null && _fo$if !== void 0 ? _fo$if : [])) {
                // replace it
                const index = metaRc.fixedOfferings.indexOf(found);
                metaRc.fixedOfferings.splice(index, 1, fo);
              }
            });
          }
        });
      }
    };
    this.matchFlagRegex = (flags, regexArray) => {
      //user provided If array in the config
      //for simple words it works like so:
      //e.g. [flag1,flag2,flag3] = flag1 || flag2 || flag3
      // but the user can also give complex regex
      //e.g. [^(?=.*flag1)(?=.*flag2)(?=.*(flag4|(?=.*flag7)(?=.*flag8))).*$] = flag1 && flag2 && (flag4||(flag7&&flag8))
      const flagString = Object.keys(flags).sort().reverse().join(',');
      try {
        return regexArray.some(regex => new RegExp(regex).test(flagString));
      } catch (error) {
        return false;
      }
    };
    this.question = question;
    this.selections = selections;
    this.metadata = metadata;
  }
  updateMetaData() {
    this.handleFlags(this.question.enable, this.selections[0]);
    return this.handleCharacteristics(this.question.characteristics);
  }
  handleCharacteristics() {
    let characteristics = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    characteristics.forEach(characteristic => {
      var _characteristic$categ;
      (_characteristic$categ = characteristic.category) === null || _characteristic$categ === void 0 ? void 0 : _characteristic$categ.forEach(category => {
        this.handleMinRange(characteristic, category);
        this.handleMaxRange(characteristic, category);
        this.handleFilters(characteristic, category);
        this.handleWeights(characteristic, category);
        this.handleTargetPoints(characteristic, category);
        this.handleTargetValues(characteristic, category);
        this.handleTargetStringValues(characteristic, category);
      });
    });
    return this.metadata;
  }
  getCharacteristicName(characteristic) {
    return characteristic.name || this.question.characteristicName;
  }
  getConversionFactor() {
    return this.question.conversionFactor || 1;
  }
  getIsCumulative() {
    return this.question.cumulative;
  }
  getValue(value) {
    const conversionFactor = this.getConversionFactor();
    value = value.toString().replace('{{value}}', this.selections[0]);
    return parseFloat(value) * conversionFactor;
  }
  handleFlags(enable, selection) {
    if (!enable) {
      return;
    }
    if (!this.metadata.flags) {
      this.metadata.flags = {};
    }
    enable.forEach(enableFlag => this.metadata.flags[enableFlag.replace('{{value}}', selection)] = true);
  }
  handleFilters(characteristic, category) {
    if ((characteristic === null || characteristic === void 0 ? void 0 : characteristic.filter) === undefined) {
      return;
    }
    const characteristicName = this.getCharacteristicName(characteristic);
    const selection = characteristicName === _constants.ADDITIONAL_PLANS_CHARACTERISTIC && this.metadata.flags.otherPlan ? this.selections[0] + 1 : this.selections[0];
    const filter = characteristic.filter.map(filterItem => filterItem.replace('{{value}}', selection));
    this.checkCategory(category);
    if (!this.metadata[category].filters[characteristicName]) {
      this.metadata[category].filters[characteristicName] = [];
    }
    this.metadata[category].filters[characteristicName] = [...new Set([...this.metadata[category].filters[characteristicName], ...filter])];
  }
  handleMinRange(characteristic, category) {
    if ((characteristic === null || characteristic === void 0 ? void 0 : characteristic.min) === undefined) {
      return;
    }
    const characteristicName = this.getCharacteristicName(characteristic);
    const isCumulative = this.getIsCumulative();
    const value = this.getValue(characteristic.min);
    this.checkCategory(category);
    const currentRange = this.metadata[category].ranges[characteristicName];
    this.metadata[category].ranges[characteristicName] = this.getMinRange(value, currentRange, isCumulative);
  }
  handleMaxRange(characteristic, category) {
    if ((characteristic === null || characteristic === void 0 ? void 0 : characteristic.max) === undefined) {
      return;
    }
    const characteristicName = this.getCharacteristicName(characteristic);
    const isCumulative = this.getIsCumulative();
    const value = this.getValue(characteristic.max);
    this.checkCategory(category);
    const currentRange = this.metadata[category].ranges[characteristicName];
    this.metadata[category].ranges[characteristicName] = this.getMaxRange(value, currentRange, isCumulative);
  }
  handleWeights(characteristic, category) {
    var _this$metadata$catego;
    if ((characteristic === null || characteristic === void 0 ? void 0 : characteristic.weight) === undefined) {
      return;
    }
    const characteristicName = this.getCharacteristicName(characteristic);
    this.checkCategory(category);
    this.metadata[category].weights[characteristicName] = this.getValue(characteristic.weight) + (this.getIsCumulative() ? (_this$metadata$catego = this.metadata[category].weights[characteristicName]) !== null && _this$metadata$catego !== void 0 ? _this$metadata$catego : 0 : 0);
  }
  handleTargetPoints(characteristic, category) {
    var _this$metadata$catego2;
    if ((characteristic === null || characteristic === void 0 ? void 0 : characteristic.targetPoint) === undefined) {
      return;
    }
    const characteristicName = this.getCharacteristicName(characteristic);
    this.checkCategory(category);
    this.metadata[category].targetPoints[characteristicName] = Math.min(Math.round((this.getValue(characteristic.targetPoint) + (this.getIsCumulative() ? (_this$metadata$catego2 = this.metadata[category].targetPoints[characteristicName]) !== null && _this$metadata$catego2 !== void 0 ? _this$metadata$catego2 : 0 : 0)) * 100) / 100, 1);
  }
  handleTargetValues(characteristic, category) {
    var _this$metadata$catego3;
    if ((characteristic === null || characteristic === void 0 ? void 0 : characteristic.targetValue) === undefined) {
      return;
    }
    const characteristicName = this.getCharacteristicName(characteristic);
    this.checkCategory(category);
    this.metadata[category].targetValues[characteristicName] = this.getValue(characteristic.targetValue) + (this.getIsCumulative() ? (_this$metadata$catego3 = this.metadata[category].targetValues[characteristicName]) !== null && _this$metadata$catego3 !== void 0 ? _this$metadata$catego3 : 0 : 0);
  }
  handleTargetStringValues(characteristic, category) {
    var _characteristic$targe;
    if ((characteristic === null || characteristic === void 0 ? void 0 : characteristic.targetStringValue) === undefined) {
      return;
    }
    const characteristicName = this.getCharacteristicName(characteristic);
    this.checkCategory(category);
    if (!this.metadata[category].targetStringValues[characteristicName]) {
      this.metadata[category].targetStringValues[characteristicName] = [];
    }
    this.metadata[category].targetStringValues[characteristicName] = [...new Set([...(this.getIsCumulative() ? this.metadata[category].targetStringValues[characteristicName] : []), ...((_characteristic$targe = characteristic.targetStringValue) === null || _characteristic$targe === void 0 ? void 0 : _characteristic$targe.map(val => {
      return val.toString().replace('{{value}}', this.selections[0]);
    }))])];
  }
}
exports.default = BaseQuestion;